var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelCppointment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "event_busy_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M0,0H37V37H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M27.667,4.083H26.125V1H23.042V4.083H10.708V1H7.625V4.083H6.083A3.092,3.092,0,0,0,3,7.167V28.75a3.092,3.092,0,0,0,3.083,3.083H27.667A3.092,3.092,0,0,0,30.75,28.75V7.167A3.092,3.092,0,0,0,27.667,4.083Zm0,24.667H6.083V13.333H27.667ZM6.083,10.25V7.167H27.667V10.25Zm4.98,14.507L12.7,26.391l3.762-3.762,3.762,3.762,1.634-1.634L18.093,21l3.762-3.762L20.22,15.6l-3.762,3.762L12.7,15.6l-1.634,1.634L14.825,21Z",
    transform: "translate(1.625 0.542)",
    fill: "#022873"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCppointment);
export default __webpack_public_path__ + "static/media/cancel_cppointment.27a70af1bf536783578b2452e18de5ec.svg";
export { ForwardRef as ReactComponent };